import BlockUi from 'react-block-ui';
import Select from 'react-select';
import { Dropdown } from 'react-bootstrap';
import { JdsButton } from '../../../components/jds/JdsButton';
import { jdsSelectProps } from '../../../components/jds/selectProps';
import '../../../components/jds/jds.css';
import DeleteItemModal from '../_modal/deleteItem';
import { useAddItemBootstrap } from './add-item.bootstrap.hook';
import { JdsMoreToggle } from '../../../components/jds/JdsMoreToggle';

export default function AddJussubItems(props) {
  const itemId = props.match.params.item_id;
  const {
    loading,
    formik,
    displayValue,
    showDeleteModal,
    setShowDeleteModal,
    isDeleting,
    statusTypeOptions,
    benefitsTypeOptions,
    selectedStatusType,
    selectedBenefitsType,
    handleValueChange,
    handleValueFocus,
    handleValueBlur,
    handleDeleteItem,
    handleCancel,
    parseBoolean,
  } = useAddItemBootstrap(itemId);

  if (loading) {
    return <div className="jds-scope">Carregando...</div>;
  }

  return (
    <BlockUi tag="div" blocking={formik.isSubmitting} className="jds-scope">
      <div className="jds-card mb-20">
        <div>
          <div className="mb-8 d-flex justify-content-between align-items-center">
            <h1 className="jds-title-lg">
              {itemId ? 'Editar produto' : 'Adicionar produto'}
            </h1>

            <div
              className="d-flex align-items-center"
              style={{ gap: 'var(--space-8)' }}
            >
              <JdsButton
                variant="outlined"
                color="neutral"
                onClick={handleCancel}
                disabled={formik.isSubmitting}
              >
                Cancelar
              </JdsButton>

              <JdsButton
                onClick={formik.handleSubmit}
                disabled={formik.isSubmitting}
              >
                Salvar produto
              </JdsButton>

              {itemId && (
                <Dropdown>
                  <Dropdown.Toggle
                    as={JdsMoreToggle}
                    variant="outlined"
                    id={`items-options-${itemId}`}
                    aria-label={`Abrir opções do produto ${itemId}`}
                  />

                  <Dropdown.Menu alignRight>
                    <Dropdown.Item onClick={() => setShowDeleteModal(true)}>
                      <span style={{ color: 'var(--fg-error-strong)' }}>
                        Excluir produto
                      </span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
          </div>

          <div className="row mb-6">
            <div className="col-12 col-md-6">
              <label htmlFor="name">
                Nome <span className="text-danger">*</span>
              </label>

              <input
                id="name"
                type="text"
                name="name"
                className={
                  'form-control ' +
                  (formik.errors.name && formik.touched.name
                    ? 'is-invalid'
                    : '')
                }
                value={formik.values.name || ''}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />

              {formik.errors.name && formik.touched.name && (
                <div className="invalid-feedback">{formik.errors.name}</div>
              )}
            </div>

            <div className="col-12 col-md-6">
              <label htmlFor="code">
                Código do produto <span className="text-danger">*</span>
              </label>

              <input
                id="code"
                type="text"
                name="code"
                className={
                  'form-control ' +
                  (formik.errors.code && formik.touched.code
                    ? 'is-invalid'
                    : '')
                }
                value={formik.values.code || ''}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />

              {formik.errors.code && formik.touched.code && (
                <div className="invalid-feedback">{formik.errors.code}</div>
              )}
            </div>

            <div className="col-12 col-md-6">
              <label>
                Status <span className="text-danger">*</span>
              </label>

              <Select
                name="statusType"
                options={statusTypeOptions}
                {...jdsSelectProps}
                placeholder="Selecione..."
                value={selectedStatusType}
                onChange={(option) => {
                  formik.setFieldValue(
                    'statusType',
                    option ? option.value : '',
                  );
                  formik.setFieldTouched('statusType', true);
                }}
                onBlur={() => {
                  formik.setFieldTouched('statusType', true);
                }}
                className={
                  formik.errors.statusType && formik.touched.statusType
                    ? 'is-invalid'
                    : ''
                }
              />

              {formik.errors.statusType && formik.touched.statusType && (
                <div className="invalid-feedback d-block">
                  {formik.errors.statusType}
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-md-6 mb-6">
              <label htmlFor="value">
                Valor <span className="text-danger">*</span>
              </label>

              <input
                id="value"
                type="text"
                name="value"
                className={
                  'form-control ' +
                  (formik.errors.value && formik.touched.value
                    ? 'is-invalid'
                    : '')
                }
                value={displayValue}
                onChange={handleValueChange}
                onFocus={handleValueFocus}
                onBlur={handleValueBlur}
              />

              {formik.errors.value && formik.touched.value && (
                <div className="invalid-feedback">{formik.errors.value}</div>
              )}
            </div>

            <div className="col-12 col-md-6 mb-6">
              <label>
                Tipo de benefício <span className="text-danger">*</span>
              </label>

              <Select
                name="benefitType"
                options={benefitsTypeOptions}
                {...jdsSelectProps}
                placeholder="Selecione..."
                value={selectedBenefitsType}
                onChange={(option) => {
                  formik.setFieldValue(
                    'benefitType',
                    option ? option.value : '',
                  );
                  formik.setFieldTouched('benefitType', true);
                }}
                onBlur={() => {
                  formik.setFieldTouched('benefitType', true);
                }}
                className={
                  formik.errors.benefitType && formik.touched.benefitType
                    ? 'is-invalid'
                    : ''
                }
              />

              {formik.errors.benefitType && formik.touched.benefitType && (
                <div className="invalid-feedback d-block">
                  {formik.errors.benefitType}
                </div>
              )}
            </div>

            <div className="col-12 col-md-6 mb-6">
              <div className="d-flex align-items-center">
                <label
                  htmlFor="display_client"
                  className="d-flex align-items-center mb-0"
                  style={{ gap: 'var(--space-8)' }}
                >
                  <input
                    id="display_client"
                    type="checkbox"
                    name="display_client"
                    checked={parseBoolean(formik.values.display_client)}
                    onChange={(event) => {
                      formik.setFieldValue(
                        'display_client',
                        event.target.checked,
                      );
                    }}
                    onBlur={() => {
                      formik.setFieldTouched('display_client', true);
                    }}
                  />
                  <span>
                    Visível para o cliente{' '}
                    <span className="text-danger">*</span>
                  </span>
                </label>
              </div>

              {formik.errors.display_client &&
                formik.touched.display_client && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.display_client}
                  </div>
                )}
            </div>
          </div>
        </div>

        {showDeleteModal && (
          <DeleteItemModal
            onConfirm={handleDeleteItem}
            onClose={() => setShowDeleteModal(false)}
            isLoading={isDeleting}
          />
        )}
      </div>
    </BlockUi>
  );
}
